import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component';
import { PrintPolicyFormComponent } from '../print-policy-form/print-policy-form.component';

@Component({
  selector: 'ngx-print-policy-list',
  templateUrl: './print-policy-list.component.html',
  styleUrls: ['./print-policy-list.component.scss']
})
export class PrintPolicyListComponent  extends BaseListComponent {
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor() {
    super()
    this.inputEditorform = PrintPolicyFormComponent;
    this.FillData();
  }
  ngOnInit() {
    this.apiName= "PrintPolicy";
    this.label = this.translate('ClientApp.FrontOffice.PrintPolicy.PrintPolicy');
    this.areaName = "RestaurantSale";
  }
  async FillData(){
    const currentBranch = this.accountService.authService.currentInformation();
    if (currentBranch.RestaurantCallCenter) {
        if(this.accountService.authService.currentBranch.AccessToAllBranches){
          this.isAdd = false;
          this.isEdit = false;
          this.isDelete = false;
        }
       
    }
  }
}
